import { Classroom } from '@teetsh/app/src/types/classroom';
import _intersectionBy from 'lodash-es/intersectionBy';
import { Tag } from '@teetsh/app/src/types/event';

export function getCommonTags(classrooms: Classroom[]): Tag[] {
  if (classrooms.length === 0) {
    return [];
  }
  if (classrooms.length === 1) {
    return classrooms[0].tags;
  }

  const tagsArray = classrooms.map(classroom => classroom.tags);
  const [first, ...rest] = tagsArray;
  return rest.reduce((acc, num) => _intersectionBy(num, acc, t => t.id), first);
}

export default function getFirstTagOfClassrooms(
  classrooms: Classroom[],
): Tag | undefined {
  if (classrooms.length === 0) {
    return undefined;
  }
  if (classrooms.length > 1) {
    const commonTags = getCommonTags(classrooms);
    if (commonTags.length > 0) {
      return commonTags[0];
    }
    return undefined;
  }
  if ((classrooms[0]?.tags || []).length === 0) {
    return undefined;
  }
  return classrooms[0]?.tags[0];
}
